const mapHttpsUriToWss = (httpsUrl: string) =>
  httpsUrl.replace(/(http)(s)?:\/\//, "wss://");

export default mapHttpsUriToWss;
